import CELL_DATA_TYPES from '../cell-types.config';

// System Health module configurations
const LISTING_COLUMNS = [
  {
    id: 'title',
    label: 'Video',
    width: '30%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TOOLTIP_TEXT,
  },
  {
    id: 'quality_video',
    label: 'Video URL',
    width: '10%',
    align: 'center',
    dataKey: 'quality_video',
    sortable: false,
    type: CELL_DATA_TYPES.HEALTH_CHECK_LABEL,
  },
  {
    id: 'quality_trailer',
    label: 'Trailer URL',
    width: '10%',
    align: 'center',
    dataKey: 'quality_trailer',
    sortable: false,
    type: CELL_DATA_TYPES.HEALTH_CHECK_LABEL,
  },
  {
    id: 'quality_poster_16x9',
    label: 'Poster 16x9 URL',
    width: '10%',
    align: 'center',
    dataKey: 'quality_poster_16x9',
    sortable: false,
    type: CELL_DATA_TYPES.HEALTH_CHECK_LABEL,
  },
  {
    id: 'quality_subtitle',
    label: 'Subtitles (en) URL',
    width: '10%',
    align: 'center',
    dataKey: 'quality_subtitle',
    sortable: false,
    type: CELL_DATA_TYPES.HEALTH_CHECK_LABEL,
  },
  {
    id: 'quality_source_url',
    label: 'Video Source URL',
    width: '10%',
    align: 'center',
    dataKey: 'quality_source_url',
    sortable: false,
    type: CELL_DATA_TYPES.HEALTH_CHECK_LABEL,
  },
];

export default LISTING_COLUMNS;
